var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21509 0.913451 7.4078C0.00519943 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.8071 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0866C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6935 24 14.3734 24 12C23.9966 8.81846 22.7312 5.76821 20.4815 3.51852C18.2318 1.26883 15.1815 0.00344108 12 0V0ZM12 22C10.0222 22 8.08879 21.4135 6.4443 20.3147C4.79981 19.2159 3.51809 17.6541 2.76121 15.8268C2.00433 13.9996 1.8063 11.9889 2.19215 10.0491C2.578 8.10929 3.53041 6.32746 4.92894 4.92893C6.32746 3.53041 8.10929 2.578 10.0491 2.19215C11.9889 1.8063 13.9996 2.00433 15.8268 2.7612C17.6541 3.51808 19.2159 4.79981 20.3147 6.4443C21.4135 8.08879 22 10.0222 22 12C21.9971 14.6513 20.9426 17.1931 19.0679 19.0679C17.1931 20.9426 14.6513 21.9971 12 22Z",
    fill: "#3D4151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 10.0003H10.9999C10.7347 10.0003 10.4803 10.1057 10.2928 10.2932C10.1052 10.4807 9.99988 10.7351 9.99988 11.0003C9.99988 11.2655 10.1052 11.5199 10.2928 11.7074C10.4803 11.8949 10.7347 12.0003 10.9999 12.0003H11.9999V18.0003C11.9999 18.2655 12.1052 18.5199 12.2928 18.7074C12.4803 18.8949 12.7347 19.0003 12.9999 19.0003C13.2651 19.0003 13.5194 18.8949 13.707 18.7074C13.8945 18.5199 13.9999 18.2655 13.9999 18.0003V12.0003C13.9999 11.4699 13.7892 10.9612 13.4141 10.5861C13.039 10.211 12.5303 10.0003 11.9999 10.0003Z",
    fill: "#3D4151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.99969C12.8284 7.99969 13.5 7.32811 13.5 6.49969C13.5 5.67126 12.8284 4.99969 12 4.99969C11.1716 4.99969 10.5 5.67126 10.5 6.49969C10.5 7.32811 11.1716 7.99969 12 7.99969Z",
    fill: "#3D4151"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.58774018049dafb6d8a8e219612667c1.svg";
export { ForwardRef as ReactComponent };